<script lang="ts" setup>
import { ShortCodeSubmit, ShortCodeRemove, shortcodeName } from '../tinymce/plugins/shortcode/plugin';
import { editorAPI } from '#layers/core/app/components/edito/editor/api';

const model = defineModel<string>({ default: '' });
const props = withDefaults(defineProps<{
    enabled?: boolean;
}>(), {
    enabled: false
});

const show = ref(false);
const shortCodeItem: any = ref({
    id: null,
    formId: null,
    typeId: null,
    closeConfigurator: false
});

const closeModalShortCodesTypes = (id: number, name: string, formId: number, typeId: number): void =>
{
    nextTick(() =>
    {
        const document = ShortCodeSubmit(editorAPI().activeEditor, id, name, formId, typeId);

        model.value = document;
        show.value = false;
    });
};

const removeShortCode = (id: number): void =>
{
    nextTick(() =>
    {
        const document = ShortCodeRemove(editorAPI().activeEditor, id);

        model.value = document;
    });
};

defineExpose({
    init(editor: any)
    {
        editor.ui.registry.addContextToolbar(shortcodeName, {
            predicate: (node: any) =>
                !editor.selection.isCollapsed() &&
                !(
                    node.nodeName === 'DIV' &&
                    (node as HTMLElement).hasAttribute('data-shortcode')
                ),
            items: 'image link media template codesample quicktable | charmap emoticons hr | nonbreaking anchor',
            position: 'selection',
            scope: 'node'
        });

        editor.addCommand('openShortCodesModal', (id: number, data: Record<string, unknown>) =>
        {
            show.value = true;
            shortCodeItem.value.id = id;
            shortCodeItem.value.formId = data?.formId || false;
            shortCodeItem.value.typeId = data?.typeId || false;
        });
    }
});
</script>

<template>
    <IdeoModal v-if="props.enabled" v-model="show" :title="$t('[[[Konfiguracja shortcode]]]')" size="xl" @close="shortCodeItem.closeConfigurator = true">
        <template #default>
            <ShortcodesModal
                :edit-id="shortCodeItem.id"
                :form-id="shortCodeItem.formId"
                :type-id="shortCodeItem.typeId"
                :close-configurator="shortCodeItem.closeConfigurator"
                @close="closeModalShortCodesTypes"
                @remove-short-code="removeShortCode"
            />
        </template>
        <template #modal-footer="{ cancel }">
            <IdeoButton variant="dark" @click.stop.prevent="cancel">
                {{ $t('[[[Zamknij]]]') }}
            </IdeoButton>
        </template>
    </IdeoModal>
</template>
